import $ from "jquery";
import _ from "lodash";
export const getSelectedIds = (checkedListSelector) => $(checkedListSelector)
    .find("[data-checked-list-item]")
    .toArray()
    .filter((i) => i.checked)
    .map((i) => $(i).data("checked-list-item-id"));
const setAllCheckboxes = (checkedList) => {
    const selectAll = checkedList.find("[data-checked-list-select-all]");
    const selectAllChecked = selectAll[0].checked;
    checkedList
        .find("[data-checked-list-item], [data-checked-list-select-all]")
        .toArray()
        .forEach((i) => (i.checked = selectAllChecked));
    const parentList = checkedList.parent().closest("[data-checked-list]");
    if (_.some(parentList))
        setSelectAll(parentList);
};
const setSelectAll = (checkedList) => {
    const selectAll = checkedList.find("[data-checked-list-select-all]")[0];
    const listItems = checkedList
        .find("[data-checked-list-item]")
        .toArray();
    selectAll.checked = _.every(listItems, (i) => i.checked);
    const parentList = checkedList.parent().closest("[data-checked-list]");
    if (_.some(parentList))
        setSelectAll(parentList);
};
$(document).on("change", "[data-checked-list-select-all]", (e) => setAllCheckboxes($(e.target).closest("[data-checked-list]")));
$(document).on("change", "[data-checked-list-item]", (e) => setSelectAll($(e.target).closest("[data-checked-list]")));
